export default "__VITE_ASSET__CIyqh3HD__"